const ENDPOINTS = {
  GET_MODELS: "/model/list",
  GET_MODELS_ME: "/model/list/me",
  GET_ALL_MODELS: "/model/list",
  CREATE_MODEL: "/model/create",
  UPDATE_MODEL: "/model/update",
  DELETE_MODEL: "/model/delete",
  GET_MODEL_PROVIDER: (modelProviderId) => `/model/providers/${modelProviderId}`,
  UPDATE_MODEL_PROVIDER: (modelProviderId) => `/model/providers/${modelProviderId}`,
  DELETE_MODEL_PROVIDER: (modelProviderId) => `/model/providers/${modelProviderId}`,
  LIST_MODEL_PROVIDERS: "/model/providers/list",
  GET_MODEL_DEFAULTS: "/model/defaults/get",
  UPDATE_MODEL_DEFAULTS: "/model/defaults/update",
  CREATE_SPECTRA: "/spectra/create_spectra",
  MOVE_CHAT: "/spark/move_spark",
  CREATE_SPARK: "/spark/create_spark",
  DELETE_SPECTRA: "/spectra/delete_spectra",
  LEAVE_SPECTRA: "/spectra/leave_spectra",
  EDIT_SPECTRA: "/spectra/edit_spectra",
  CHECK_TAG: (orgId, tag) => `/spectra/check-tag/${orgId}/${encodeURIComponent(tag)}`,
  GET_USER_TAGS: (orgId, userId) => `/spectra/tags/${orgId}/${userId}`,
  UPDATE_ANSWER_CONTENT: "/spark/update_answer_content",
  UPDATE_SPARK_TITLE: "/spark/update_spark_title",
  PIN_SPARK: "/spark/pin_spark",
  PIN_SPECTRA: "/spectra/pin_spectra",
  ADD_FILE_TO_SPARK: "/spark/add_file",
  REMOVE_FILE_FROM_SPARK: "/spark/remove_file",
  RECACHE_SPARK: "/spark/recache",
  DELETE_MESSAGE: "/spark/delete_message",
  ADD_COLLABORATOR: "/collaborator/add_collaborator",
  REMOVE_COLLABORATOR: "/collaborator/remove_collaborator",
  SET_CHAT_MODEL: "/spark/set_spark_model",
  GET_FILE_DATA: "/spectra/get_file_data",
  SPECTRA_ACTIVITIES: (orgId, spaceId, limit = 20, offset = 0) => 
    `/audit/spectra/${orgId}/${spaceId}?limit=${limit}&offset=${offset}`,
  SPECTRA_SPARKS: (spaceId, orgId, userId, ownerId) => {
    let url = `/spectra/${spaceId}/sparks/${orgId}/${userId}`;
    if (ownerId) url += `?owner_id=${ownerId}`;
    return url;
  },
  SPECTRA_BY_ID: (spaceId, orgId, userId) => 
    `/spectra/${spaceId}/${orgId}/${userId}`,
  SPECTRA_OWNER: (spaceId, orgId, userId) =>
    `/spectra/${spaceId}/owner/${orgId}/${userId}`,
  SPECTRA_DETAILS: (spaceId, orgId, userId, ownerId, params = {}) => {
    const queryParams = new URLSearchParams({
      org_id: orgId,
      user_id: userId,
      ...(ownerId && { owner_id: ownerId }), // Only include if not null
      include_activities: params.include_activities ?? true,
      include_sparks: params.include_sparks ?? true,
      activity_limit: params.activity_limit ?? 10,
      ...(params.spark_limit && { spark_limit: params.spark_limit })
    });
    return `/spectra/details/${spaceId}?${queryParams.toString()}`;
  },
  GENERATE_API: "/spark/generate",
  STOP_GENERATION: "/spark/stop_generation",
  GET_SECRETS: "/admin/get_secret",
  PASSWORD_RESET: "/api/auth/password-reset",
  GET_SPARKS: "/spark/get_sparks",
  GET_MESSAGES: (chatId, orgId, userId, spaceId, ownerId) => {
    let url = `/spark/get_messages/${chatId}/${orgId}/${userId}`;
    const params = [];
    if (spaceId) params.push(`space_id=${spaceId}`);
    if (ownerId) params.push(`owner_id=${ownerId}`);
    return params.length > 0 ? `${url}?${params.join('&')}` : url;
  },
  LIST_AGENTS: "/agent/list_agent_trigger",
  GET_AGENTS: "/agent/list_agents",
  
  // Preferences
  GET_MODEL_PREFERENCES: "/preferences/models",
  UPDATE_MODEL_PREFERENCES: "/preferences/models",
  TOGGLE_MODEL: "/preferences/models",
  SET_DEFAULT_MODEL: "/preferences/models",

  // Appearance Preferences
  GET_APPEARANCE_PREFERENCES: "/preferences/appearance",
  UPDATE_APPEARANCE_PREFERENCES: "/preferences/appearance",
  PROFILE_PREFERENCES: "/preferences/profile",
  LOCALIZATION_PREFERENCES: "/preferences/localization",
  STYLES: "/preferences/styles",
  STYLE: (styleId) => `/preferences/styles/${styleId}`,
  ACTIVE_STYLE: "/preferences/styles/active",

  // SSE channel subscription management

  // Desktop Bridge — list all devices for the current user (no client_id needed; powers Prompt-bar selector)
  DESKTOP_CAPABILITIES: '/api/v1/desktop/registry/capabilities',
  DESKTOP_USER_DEVICES: '/api/v1/desktop/registry/user-devices',
  // Desktop Bridge — durable device history from Firestore (Phase G2); includes offline + revoked
  DESKTOP_USER_DEVICE_HISTORY: '/api/v1/desktop/registry/user-devices/history',
  // Desktop Bridge — revoke a specific device (Phase G3)
  DESKTOP_REVOKE_DEVICE: (clientId, deviceId) => `/api/v1/desktop/registry/clients/${encodeURIComponent(clientId)}/devices/${encodeURIComponent(deviceId)}/revoke`,
  // Desktop Bridge — initiate device enrollment OTP email (Phase 6)
  DESKTOP_ENROLL_INIT: '/api/v1/desktop/registry/devices/enroll/init',


  CHAT_MODEL_INFO: (chat_id, user_id, org_id, space_id) =>
    space_id
      ? `/spark/get_spark_info?chat_id=${chat_id}&user_id=${user_id}&org_id=${org_id}&space_id=${space_id}`
      : `/spark/get_spark_info?chat_id=${chat_id}&user_id=${user_id}&org_id=${org_id}`,

  // Admin User Management
  ADMIN_LIST_USERS: "/admin/users/list",
  ADMIN_INVITE_USER: "/admin/users/invite",
  ADMIN_DISABLE_USER: (userId) => `/admin/users/${userId}`,
  ADMIN_RESTORE_USER: (userId) => `/admin/users/${userId}/restore`,
  ADMIN_UPDATE_USER: (userId) => `/admin/users/${userId}`,
  ADMIN_UPDATE_USER_NAME: (userId) => `/admin/users/${userId}/name`,
  ADMIN_RESET_USER_PASSWORD: (userId) => `/admin/users/${userId}/reset-password`,
  ADMIN_RESEND_INVITE: (userId) => `/admin/users/${userId}/resend-invite`,
  ADMIN_CANCEL_INVITE: (userId) => `/admin/users/${userId}/cancel-invite`,
  ADMIN_PURGE_USER: (userId) => `/admin/users/${userId}/purge`,

  // Admin Org Settings
  ADMIN_ORG_SETTINGS: "/admin/org/settings",
  ADMIN_BREAK_GLASS_ACCOUNTS: "/admin/break-glass-accounts",
  ADMIN_BREAK_GLASS_ACCOUNT: (email) =>
    `/admin/break-glass-accounts/${encodeURIComponent(email)}`,

  // Admin Client (App) Management
  ADMIN_LIST_CLIENTS: "/admin/clients",
  ADMIN_REGISTER_CLIENT: "/admin/clients",
  ADMIN_GET_CLIENT: (clientId) => `/admin/clients/${clientId}`,
  ADMIN_UPDATE_CLIENT: (clientId) => `/admin/clients/${clientId}`,
  ADMIN_DELETE_CLIENT: (clientId) => `/admin/clients/${clientId}`,
  ADMIN_REVOKE_CLIENT: (clientId) => `/admin/clients/${clientId}/revoke`,
  ADMIN_ENABLE_CLIENT: (clientId) => `/admin/clients/${clientId}/enable`,
  ADMIN_ROTATE_CLIENT: (clientId) => `/admin/clients/${clientId}/rotate`,
  ADMIN_LIST_CLIENT_SUBJECTS: (clientId) => `/admin/clients/${clientId}/subjects`,
  ADMIN_TOMBSTONE_SUBJECT: (clientId, linkId) => `/admin/clients/${clientId}/subjects/${linkId}/tombstone`,
  ADMIN_DECOMMISSION_DEVICE: (clientId, deviceId) => `/admin/clients/${clientId}/subjects/${deviceId}/decommission`,
  ADMIN_DELETE_CLIENT_INVITE: (clientId, inviteId) => `/admin/clients/${clientId}/invites/${inviteId}`,
  ADMIN_CREATE_CLIENT_INVITE: (clientId) => `/admin/clients/${clientId}/invites`,
  ADMIN_LIST_CLIENT_INVITES: (clientId) => `/admin/clients/${clientId}/invites`,
  ADMIN_REVOKE_CLIENT_INVITE: (clientId, inviteId) => `/admin/clients/${clientId}/invites/${inviteId}`,

  // Admin Audit Sinks
  ADMIN_LIST_AUDIT_SINKS: "/admin/audit/sinks",
  ADMIN_CREATE_AUDIT_SINK: "/admin/audit/sinks",
  ADMIN_UPDATE_AUDIT_SINK: (sinkId) => `/admin/audit/sinks/${sinkId}`,
  ADMIN_DELETE_AUDIT_SINK: (sinkId) => `/admin/audit/sinks/${sinkId}`,
  ADMIN_TEST_AUDIT_SINK: (sinkId) => `/admin/audit/sinks/${sinkId}/test`,
  ADMIN_FLUSH_AUDIT_SINK: (sinkId) => `/admin/audit/sinks/${sinkId}/flush`,
  ADMIN_AUDIT_LOG: "/admin/audit/log",

  // Admin FinOps
  ADMIN_FINOPS_SUMMARY: "/admin/finops/summary",

  // Admin Group Management
  ADMIN_LIST_GROUPS: (orgId) => `/group/list?org_id=${orgId}`,
  ADMIN_GET_GROUP: (groupId, orgId) => `/group/${groupId}?org_id=${orgId}`,
  ADMIN_CREATE_GROUP: "/group/create",
  ADMIN_UPDATE_GROUP: (groupId) => `/group/${groupId}`,
  ADMIN_DELETE_GROUP: (groupId) => `/group/${groupId}`,
  ADMIN_LIST_GROUP_MEMBERS: (groupId, orgId) => `/group/${groupId}/members?org_id=${orgId}`,
  ADMIN_ADD_GROUP_MEMBER: (groupId) => `/group/${groupId}/members`,
  ADMIN_REMOVE_GROUP_MEMBER: (groupId, userId) => `/group/${groupId}/members/${userId}`,
  ADMIN_GET_USER_GROUPS: (userId, orgId) => `/group/user/${userId}/groups?org_id=${orgId}`,
  ADMIN_GET_USER_RESOLVED_POLICY: (userId, orgId) => `/group/user/${userId}/resolved-policy?org_id=${orgId}`,
  ADMIN_GET_GROUP_POLICY: (groupId, orgId) => `/group/${groupId}/policy?org_id=${orgId}`,
  ADMIN_SET_GROUP_POLICY: (groupId) => `/group/${groupId}/policy`,
  ADMIN_GET_GROUP_AUDIT_LOG: (groupId, orgId) => `/group/${groupId}/audit?org_id=${orgId}`,
  ADMIN_GET_ORG_DEFAULT_POLICY: (orgId) => `/group/org/default-policy?org_id=${orgId}`,
  ADMIN_SET_ORG_DEFAULT_POLICY: "/group/org/default-policy",

  // Google Workspace Integration
  ADMIN_GW_CONFIG: "/admin/google-workspace/config",
  ADMIN_GW_REGISTER_GROUP: "/group/google-workspace/register",
  ADMIN_GW_SYNC_GROUP: (groupId) => `/group/${groupId}/sync`,

  // Message Export
  EXPORT_MESSAGE: "/spark/export_message",

  // Scheduler
  SCHEDULER_JOBS: "/scheduler/jobs",
  SCHEDULER_JOB: (jobId) => `/scheduler/jobs/${jobId}`,
  ADMIN_SCHEDULER_JOBS: "/scheduler/admin/jobs",

  // Generation lifecycle (Phase 2 reconnect)
  GENERATION_STATUS: (genId) => `/spark/generation/${genId}`,
  GENERATION_STREAM: (genId, afterSeq = 0) => `/spark/generation/${genId}/stream?after_seq=${afterSeq}`,

  // Notifications
  NOTIFICATIONS: "/notifications",
  NOTIFICATION_READ: (notificationId) => `/notifications/${notificationId}/read`,
  NOTIFICATIONS_READ_ALL: "/notifications/read-all",

  // Persistent Memory
  GET_PERSISTENT_MEMORY: (orgId, userId, chatId) => `/spark/memory/${orgId}/${userId}/${chatId}`,
  SUPERSEDE_MEMORY_ENTRY: (orgId, userId, chatId, index) =>
    `/spark/memory/${orgId}/${userId}/${chatId}/${index}/supersede`,

  // Artifact Versioning
  ANSWER_VERSIONS: (chatId, answerId, ownerId, spaceId) =>
    `/spark/answer-versions?chat_id=${encodeURIComponent(chatId)}&answer_id=${encodeURIComponent(answerId)}`
    + `${ownerId ? `&owner_id=${encodeURIComponent(ownerId)}` : ""}`
    + `${spaceId ? `&space_id=${encodeURIComponent(spaceId)}` : ""}`,
  ANSWER_VERSION: (chatId, answerId, versionNumber, ownerId, spaceId) =>
    `/spark/answer-version?chat_id=${encodeURIComponent(chatId)}&answer_id=${encodeURIComponent(answerId)}`
    + `&version_number=${encodeURIComponent(versionNumber)}`
    + `${ownerId ? `&owner_id=${encodeURIComponent(ownerId)}` : ""}`
    + `${spaceId ? `&space_id=${encodeURIComponent(spaceId)}` : ""}`,
  PIN_ANSWER_VERSION: "/spark/pin-answer-version",

  // Inline AI Editor
  EDIT_ARTIFACT: "/spark/edit-artifact",

  // Admin Service Config
  ADMIN_SERVICE_CONFIG: (service) => `/admin/config/${service}`,
  ADMIN_SERVICE_CREDENTIAL: (service) => `/admin/config/${service}/credential`,
  ADMIN_AUTH_CREDENTIAL: (name) => `/admin/config/auth/credential/${name}`,
  ADMIN_AUTH_CREDENTIAL_SEAL: (name) => `/admin/config/auth/credential/${name}/seal`,
  ADMIN_JWT_ROTATION_ACTIVATE: "/admin/config/auth/credential/jwt/activate",
  ADMIN_JWT_ROTATION_COMPLETE: "/admin/config/auth/credential/jwt/complete",
  ADMIN_JWT_ROTATION_CANCEL_COMPLETE: "/admin/config/auth/credential/jwt/cancel-complete",
  ADMIN_GLUON_CREDENTIAL: (name) => `/admin/config/gluon_link/credential/${name}`,
  ADMIN_GLUON_KEYPAIR_ROTATE: "/admin/config/gluon_link/credential/keypair/rotate",
  ADMIN_GLUON_KEYPAIR_SEAL:   "/admin/config/gluon_link/credential/keypair/seal",
  ADMIN_SCHEDULER_DEPLOY: "/admin/config/scheduler/deploy",
};

export default ENDPOINTS;
